import React from 'react';
import cx from 'classnames';

import { formatDate } from '@shootsta/get-moment';
import { LucideIcon as Icon, Text, Link } from '../../../../../ui-kit';
import { Trash2, Pencil } from 'lucide-react';
import UserProfile from '../../../common/UserProfile/UserProfile';
import '../styles/_comment-footer.scss';










function CommentFooter({
  user: { imageUrl, name, isUser },
  updatedAt,
  handleDelete,
  handleEdit,
  isResourceOwner,
  handleClickReply
}) {
  const isUpdateDeletePermission = isUser || isResourceOwner;

  return (
      <div className="comment-footer">

      <UserProfile imageUrl={imageUrl} name={name} isUser={isUser} />
      <Text
        noMargin
        timestamp
        className="ml-auto !text-[#8A94A6]">
        {formatDate(updatedAt, 'MMM D [at] hh:mm A')}
      </Text>
      <div className="comment-footer__right">
        {handleClickReply &&
        <Link button onClick={handleClickReply}>Reply</Link>}


        {handleEdit && isUpdateDeletePermission &&
        <Icon
          icon={Pencil}
          color="regent"
          hoverColor="darkDenim"
          size={16}
          onClick={handleEdit}
          wrapperClassName="flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" />}



        {handleDelete && isUpdateDeletePermission &&
        <Icon
          icon={Trash2}
          color="regent"
          hoverColor="redApple"
          size={16}
          onClick={handleDelete}
          wrapperClassName="flex items-center justify-center h-6 w-6 rounded-full cursor-pointer transition-colors duration-150 hover:bg-red-50" />}



      </div>
    </div>);

}

export default CommentFooter;